import Vue from 'vue'
import main from '@/main'
import {forEach, getFormatDate} from '@/libs/tools.js'
import {getVcsMembers} from '@/api/conferencejs.js'
import Participant from './participant.js'

class Room {
  meetingParticipants = []
  ringParticipants = new Set()
  fixParticipants = {}
  tempParticipants = {}
  inviteParticipants = []
  name = ''
  no=''
  number = null
  route=null
  host=null
  intercom=null
  isVideo=false
  record = false
  forceRecord = false
  isTemp = false
  deptId = ''
  mute = false
  meeting = false
  sharing = false
  changePanel = false

  meetingInfo = []
  reloadTimeout = null
  meetingNum = 0

  constructor(name,meetingNo,meetingNumber,route,host,intercom,isVideo,record,deptId,isTemp) {
    this.name = name
    this.isTemp = isTemp
    this.deptId = deptId
    this.no = meetingNo
    this.number = meetingNumber
    this.route = route
    this.host = host
    this.intercom = intercom
    this.isVideo = isVideo
    this.record = record
    if (isTemp===undefined||isTemp===null) {
      this.isTemp = name.indexOf('-a-')>-1
    } else {
      this.isTemp = isTemp
    }
    if (this.isTemp) {
      this.no = this.name
      //this.number = this.name
    }
    this.meetingInfo = []
  }

  addParticipant(participant,inRoom) {
    this.meetingNum=0
    let key = participant.name
    //设置分机存储的Key为 分机号码
    if ((participant.type == 1 ||participant.type == 2) && participant.number) {
      key = participant.number
    }
    //this.meeting = this.meetingParticipants.length > 0
    if (participant.isTemp) {
      let op = this.tempParticipants[key]
      if (op && op.rtcPeer) {
        participant.rtcPeer = op.rtcPeer
        participant.speakHark = op.speakHark
      }
      Vue.set(this.tempParticipants,key,participant)
    } else {
      let op = this.fixParticipants[key]
      if (op && inRoom) {
        participant.rtcPeer = op.rtcPeer;
        participant.speakHark = op.speakHark;
        if (op.status === 'Talking') {
          participant.setStatus(op.status)
        }
      }
      //判断临时中存在不
      let tp = this.tempParticipants[key]
      if (tp) {
        delete this.tempParticipants[key]
      }
      //固定成员无rtcPeer
      Vue.set(this.fixParticipants,key,participant)
    }

    // 当 participant 被添加时，清理对应的 candidate 队列
    const candidateKey = `candidate_${key}`;
    if (this._candidateManager && this._candidateManager.has(candidateKey)) {
      const manager = this._candidateManager.get(candidateKey);
      console.log(`Participant ${key} added, clearing ${manager.queue.length} pending ICE candidates`);
      this._candidateManager.delete(candidateKey);
    }

    if (inRoom && (participant.status === 'Talking' || participant.status === 'Ringing')) {
      this.meeting = true
      if (participant.status === 'Talking') {
        if (this.meetingParticipants.indexOf(key) < 0) {
          this.meetingParticipants.push(key)
        }
        this.removeInviteParticipant('name', key)
        this.ringParticipants.delete(key)
      }else{
        this.ringParticipants.add(key)
      }
      //this.meeting = true
      main.$root.bus.$emit('meetingChange',this.meetingParticipants)
    }
    /*if (!this.meeting) {
      this.dispose()
    }*/
  }

  addMeetingNum() {
    this.meetingNum++;
  }

  changeVcsMember(json){
    let type = json.type
    let name = json.name
    let muted = json.mute
    let muteVideo = json.muteVideo
    let inviteName = name
    let shareName = json.shareName
    //先修改固定的
    let op = this.fixParticipants[name]
    if (!op) {
      op = this.tempParticipants[name]
    }
    if (op) {
      op.muted = muted
      op.muteVideo = muteVideo
      op.setStatus('Talking')
      this.meeting = true
      if (op.type == '4' || op.type == '5') {
        op.muted = true
        muted = true
      }
      if (op.muted) {
        op.meetingIcon = 'conf_mute'
      } else {
        op.meetingIcon = 'conf'
      }
      if (this.meetingParticipants.indexOf(name) < 0) {
        this.meetingParticipants.push(name)
        main.$root.bus.$emit('meetingChange',this.meetingParticipants)
      }
      inviteName = op.name
      this.removeInviteParticipant('name', op.name)
    }else {
      //需要重新生成成员
      let arr = []
      if (type === 'SIP') {
        type = 'sip'
      }else if (type==='CAMERA'){
        type='camera'
        muted = true
      }else if (type == 'SCREEN') {
        //是屏幕共享直接添加一个成员即可
        let participant = new Participant(name, this.name, '', 7, true, '');
        participant.isShare = true
        participant.isShowShare = shareName != main.$store.state.user.userName
        participant.isTemp = true
        participant.muteVideo = false
        participant.meetingIcon = 'conf'
        participant.muted = true
        participant.setStatus('Talking')
        participant.setDept('','all_area')
        //对Icon进行处理
        participant.icon = ''
        participant.net = ''
        participant.gradeName = ''
        participant.realName = shareName
        this.addParticipant(participant, true);
        this.sharing = true
        this.changePanel = true
        if (this.meetingParticipants.indexOf(name) < 0) {
          this.meetingParticipants.push(name)
          main.$root.bus.$emit('meetingChange',this.meetingParticipants)
        }
        return
      }
      let p = {name: name, type: type, mute: muted,muteVideo:muteVideo};
      arr.push(p)
      getVcsMembers(arr).then(res=>{
        let response = res.data
        if (response.code === 200) {
          let ps = response.data
          forEach(ps,d=>{
            let name1 = d.name
            if (d.channel) {
              name1 = d.name + '_' + d.channel
              //gb28181 移除
              this.removeInviteParticipant('name', d.name)
            }
            let participant = new Participant(name1, this.name, d.exten, d.type, d.vcs, d.gradeNum)
            if (d.channel) {
              participant.realName = d.name
            }
            if (!participant.number) {
              participant.number = participant.name
            }
            participant.isTemp = d.temp;
            participant.muteVideo = muteVideo
            if (d.inRoom) {
              if (d.mute) {
                participant.muted = d.mute
                participant.meetingIcon = 'conf_mute'
              } else {
                participant.meetingIcon = 'conf'
              }
            } else {
              participant.meetingIcon = ''
            }
            if (d.status === 'UnKnown') {
              d.status = 'UnKnow'
            }
            participant.setStatus(d.status)
            participant.setDept(d.deptId,d.deptName)
            //对Icon进行处理
            participant.icon = ''
            participant.net = d.net
            participant.gradeName = d.gradeName
            inviteName = d.name
            this.addParticipant(participant,d.inRoom)
          })
        }
      })

    }
    if (this.meetingParticipants.indexOf(name) < 0) {
      this.meetingParticipants.push(name)
      main.$root.bus.$emit('meetingChange',this.meetingParticipants)
    }
    //处理掉邀请
    this.removeInviteParticipant('name',inviteName)
  }

  vcsMemberLeave(json) {
    let type = json.type
    let name = json.name
    //删除开会中
    if (this.meetingParticipants.indexOf(name) > -1) {
      this.meetingParticipants.splice(this.meetingParticipants.indexOf(name),1)
      this.ringParticipants.delete(name)
      main.$root.bus.$emit('meetingChange',this.meetingParticipants)
    }
    //如果是screen
    if (type == 'SCREEN') {
      let participant = this.tempParticipants[name]
      if (participant) {
        participant.dispose();
        Vue.delete(this.tempParticipants,name)
      }
      this.sharing = false
      this.changePanel = false
      return
    }
    //判断是否是自己离开会议室
    if (type =='PC' && name === main.$store.state.user.userName) {
      if (this.meetingParticipants.length > 0) {
        for (const key in this.tempParticipants) {
          let participant = this.tempParticipants[key]
          if (participant.rtcPeer) {
            participant.dispose()
          }
        }
        for (const key in this.fixParticipants) {
          let participant = this.fixParticipants[key]
          if (participant.rtcPeer) {
            participant.dispose()
          }
        }
      }
    }
    let op = this.fixParticipants[name]
    if (!op) {
      op = this.tempParticipants[name]
      if (!op) {
        console.log('can`t find vcs member:', name)
        return
      }
      op.dispose()
      Vue.delete(this.tempParticipants,name)
      return
    }
    if (op.status === 'Talking') {
      op.status = 'Idle'
      /*if (op.type === 1 || op.type === 2) {
        op.status = 'Idle'
      }else{
        op.status = 'UnKnow'
      }*/
      if (op.type == '4' && op.isRtsp) {
        op.status = 'UnKnow'
      }
    }
    op.meetingIcon = ''

    //写入到未加入
    let invite = {}
    invite.name = op.name
    invite.type = op.type
    invite.canInvite = true
    invite.number = op.number
    this.inviteParticipants.unshift(invite)
    if (this.isTemp) {
      if (Object.keys(this.tempParticipants).length <= 0) {
        main.$store.commit('removeRoom',this)
      }
    }
    op.dispose()
  }

  /*vcsCandidate(json,number){
    let name = json.name
    let op = this.fixParticipants[name]
    if (!op) {
      op = this.tempParticipants[name]
    }
    if (!op.rtcPeer) {
      if (number === 1) {
        return
      }
      //return console.log('add ice candidate error,participant name:',op.name)
      setTimeout(()=>{
        this.vcsCandidate(json,1)
      },500)
    }
    if (!op.rtcPeer) {
      return console.error('participant :'+op.name+' no rtcpeer')
    }
    op.rtcPeer.addIceCandidate(json.candidate,function (error) {
      if (error) return console.error('Error adding candidate:', error)
    })
  }*/

  vcsCandidate(json, number) {
    const name = json.name;

    // 初始化候选队列管理器
    if (!this._candidateManager) {
      this._candidateManager = new Map();
    }

    const candidateKey = `candidate_${name}`;

    // 如果已有处理中的任务，将 candidate 加入队列
    if (this._candidateManager.has(candidateKey)) {
      const manager = this._candidateManager.get(candidateKey);
      manager.queue.push(json.candidate);
      console.log(`Queued ICE candidate for ${name}, queue size: ${manager.queue.length}`);
      return;
    }

    // 创建新的管理对象
    this._candidateManager.set(candidateKey, {
      queue: [],
      processing: false,
      retryCount: 0
    });

    // 定义最大重试次数和初始延迟
    const MAX_RETRIES = 3;
    const INITIAL_DELAY = 500;

    // 递归重试函数
    const attemptAddCandidate = (retryCount = 0) => {
      const manager = this._candidateManager.get(candidateKey);
      if (!manager) {
        return;
      }

      // 标记为处理中
      manager.processing = true;
      manager.retryCount = retryCount;

      let op = this.fixParticipants[name];
      if (!op) {
        op = this.tempParticipants[name];
      }

      if (!op || !op.rtcPeer) {
        if (retryCount >= MAX_RETRIES) {
          console.error(`Max retries (${MAX_RETRIES}) reached. Participant or RTC peer not found:`, name);
          this._candidateManager.delete(candidateKey);
          return;
        }

        console.warn(`Participant or RTC peer not found for ${name}. Retrying...`);
        return scheduleRetry(retryCount);
      }

      // 获取所有待处理的 candidates
      const currentManager = this._candidateManager.get(candidateKey);
      if (!currentManager) {
        return;
      }

      const candidatesToProcess = [json.candidate, ...currentManager.queue];
      currentManager.queue = []; // 清空队列

      console.log(`Processing ${candidatesToProcess.length} ICE candidate(s) for ${name}`);

      let processedCount = 0;
      let hasError = false;

      // 批量处理所有 candidates
      candidatesToProcess.forEach((candidate, index) => {
        op.rtcPeer.addIceCandidate(candidate, function (error) {
          processedCount++;

          if (error) {
            console.error(`Error adding candidate ${index + 1}/${candidatesToProcess.length}:`, error);
            hasError = true;
          }

          // 所有 candidates 处理完成后
          if (processedCount === candidatesToProcess.length) {
            const mgr = this._candidateManager ? this._candidateManager.get(candidateKey) : null;

            if (hasError && mgr && mgr.retryCount < MAX_RETRIES) {
              // 有错误且未达到最大重试次数，重试
              scheduleRetry(mgr.retryCount + 1);
            } else {
              // 成功或达到最大重试，清理
              if (this._candidateManager) {
                this._candidateManager.delete(candidateKey);
              }
              if (!hasError) {
                console.log(`All ICE candidates processed successfully for ${name}`);
              }
            }
          }
        }.bind(this));
      });
    };

    // 安排重试，使用指数退避算法
    const scheduleRetry = (retryCount) => {
      const delay = INITIAL_DELAY * Math.pow(2, retryCount);
      console.log(`Scheduling ICE candidate retry ${retryCount + 1}/${MAX_RETRIES} in ${delay}ms`);

      setTimeout(() => {
        attemptAddCandidate(retryCount);
      }, delay);
    };

    // 开始处理
    attemptAddCandidate();
  }

  /*vcsAnswer(json) {
    let name = json.name
    let op = this.fixParticipants[name]
    if (!op) {
      op = this.tempParticipants[name]
    }
    if (!op.rtcPeer) {
      return console.log('add ice candidate error,participant name:',op.name)
    }
    op.rtcPeer.processAnswer(json.sdpAnswer,function (error) {
      if (error) return console.error('Error sdp answer:', error)
    })
  }*/

  vcsAnswer(json) {
    const name = json.name;

    // 定义最大重试次数和初始延迟
    const MAX_RETRIES = 3;
    const INITIAL_DELAY = 500; // 毫秒

    // 递归重试函数
    const attemptProcessAnswer = (retryCount = 0) => {
      const op = this.fixParticipants[name] || this.tempParticipants[name];

      if (!op || !op.rtcPeer) {
        console.warn(`Participant or RTC peer not found for ${name}. Retrying...`);
        return scheduleRetry(retryCount);
      }

      const rtcPeer = op.rtcPeer;
      const connection = rtcPeer.peerConnection;

      // 检查连接是否已关闭
      if (connection.signalingState === 'closed') {
        return console.error('Cannot process answer: RTCPeerConnection is closed');
      }

      // 检查当前状态是否适合设置远程描述
      const canSetRemoteDescription = [
        'stable',
        'have-local-offer',
        'have-remote-offer'
      ].includes(connection.signalingState);

      if (!canSetRemoteDescription) {
        console.warn(`Current signaling state (${connection.signalingState}) is not suitable for setting remote description. Retrying...`);
        return scheduleRetry(retryCount);
      }

      rtcPeer.processAnswer(json.sdpAnswer, (error) => {
        if (error) {
          console.error(`Error processing answer (attempt ${retryCount + 1}/${MAX_RETRIES}):`, error);

          // 特殊处理InvalidStateError，进行重试
          if (error.message.includes('InvalidStateError') && retryCount < MAX_RETRIES) {
            scheduleRetry(retryCount + 1);
          }
        } else {
          console.log('SDP answer processed successfully');
        }
      });
    };

    // 安排重试，使用指数退避算法
    const scheduleRetry = (retryCount) => {
      if (retryCount >= MAX_RETRIES) {
        return console.error(`Max retries (${MAX_RETRIES}) reached for processing answer for ${name}`);
      }

      const delay = INITIAL_DELAY * Math.pow(2, retryCount);
      console.log(`Scheduling retry ${retryCount + 1}/${MAX_RETRIES} in ${delay}ms`);

      setTimeout(() => {
        attemptProcessAnswer(retryCount);
      }, delay);
    };

    // 开始处理
    attemptProcessAnswer();
  }

  clearParticipant() {
    if (!this.isVideo) {
      this.fixParticipants = {}
      this.tempParticipants = {}
      this.meetingParticipants = []
      this.ringParticipants.clear()
      this.meeting = false
    }else{
      if (!this.meeting) {
        this.fixParticipants = {}
        this.tempParticipants = {}
        this.meetingParticipants = []
        this.ringParticipants.clear()
      }
    }
  }

  getParticipants() {
    let all = []
    let gbName = new Set()
    for (const key in this.tempParticipants) {
      let participant = this.tempParticipants[key]
      if (participant.isShare && !participant.isShowShare) {
        continue;
      }
      if (participant.realName !== participant.name) {
        gbName.add(participant.realName);
      }
      all.push(this.tempParticipants[key])
    }
    let gbArr = Array.from(gbName)
    for (const key in this.fixParticipants) {
      let participant = this.fixParticipants[key]
      if (gbArr.length > 0) {
        if ((participant.type == '4' || participant.type == '5') && gbArr.indexOf(participant.name) > -1) {
          continue
        }
      }
      all.unshift(this.fixParticipants[key])
    }
    return all
  }

  getShareMember() {
    if (!this.sharing || this.tempParticipants.length === 0) {
      return null
    }
    for (const key in this.tempParticipants) {
      let participant = this.tempParticipants[key]
      if (participant.isShare) {
        return participant
      }
    }
    return null
  }

  getParticipant(name, type) {
    let fp = this.fixParticipants[name]
    let tp = this.tempParticipants[name]
    if (type === 'temp') {
      return tp
    }else if (type === 'fix') {
      return fp
    } else {
      return fp ? fp : tp
    }
  }

  getParticipantByNumber(number,appKey) {
    if (!number) {
      return null
    }
    for (const key in this.fixParticipants) {
      let participant = this.fixParticipants[key]
      /*if (participant.type !== 1) {
        continue
      }*/
      if (appKey) {
        if (appKey === participant.gradeNumber && participant.number === number) {
          return participant
        }
      }else {
        if (participant.number === number) {
          return participant
        }
      }
    }
    for (const key in this.tempParticipants) {
      let participant = this.tempParticipants[key]
      /*if (participant.type !== 1) {
        continue
      }*/
      if (appKey) {
        if (appKey === participant.gradeNumber && participant.number === number) {
          return participant
        }
      }else {
        if (participant.number === number) {
          return participant
        }
      }
    }
    return null
  }

  inFixReloadRoom(number, appKey, delay) {
    //直接修改状态就行
    let reload = false
    for (const key in this.fixParticipants) {
      let participant = this.fixParticipants[key]
      if (participant.number === number) {
        if (appKey) {
          if (appKey === participant.appKey) {
            reload = true
          }
        } else {
          reload = true
        }
      }
    }

    for (const key in this.tempParticipants) {
      let participant = this.tempParticipants[key]
      if (participant.number === number) {
        if (appKey) {
          if (appKey === participant.appKey) {
            reload = true
          }
        } else {
          reload = true
        }
      }
    }
    if (reload) {
      if (delay) {
        if (this.reloadTimer) {
          clearTimeout(this.reloadTimer)
        }
        this.reloadTimer = setTimeout(()=>{
          main.$root.bus.$emit('reloadConference', this.name)
          this.reloadTimer = null
        },delay)
      }else {
        main.$root.bus.$emit('reloadConference', this.name);
      }
    }
  }

  reloadRoom(delay) {
    if (!delay) {
      main.$root.bus.$emit('reloadConference', this.name)
    }else{
      if (this.reloadTimeout) {
        clearTimeout(this.reloadTimeout)
      }
      this.reloadTimeout = setTimeout(()=>{
        main.$root.bus.$emit('reloadConference', this.name)
      },delay)
    }
  }

  removeParticipant(key, value, appKey) {
    if (!key) {
      key = 'name'
    }
    let pt = null
    for (const pk in this.tempParticipants) {
      let participant = this.tempParticipants[pk]
      if (participant[key] === value) {
        if (appKey) {
          if (participant.appKey === appKey) {
            pt = participant
            break
          }
        } else {
          pt = participant
          break
        }

      }
    }
    if (!pt) {
      for (const pk in this.fixParticipants) {
        let participant = this.fixParticipants[pk]
        if (participant[key] === value) {
          if (appKey) {
            if (participant.appKey === appKey) {
              pt = participant
              break
            }
          } else {
            pt = participant
            break
          }
        }
      }
    }
    if (!pt) {
      if (this.meetingParticipants.length <= 0 && this.ringParticipants.size <= 0) {
        this.dispose()
      }
      return
    }
    let pKey = pt.type == 1 ? pt.number :pt.name
    if (this.meetingParticipants.indexOf(pKey) > -1) {
      this.meetingParticipants.splice(this.meetingParticipants.indexOf(pKey), 1)
      this.ringParticipants.delete(pKey)
      main.$root.bus.$emit('meetingChange',this.meetingParticipants)
    }
    if (pt.isTemp) {
      //临时移除
      this.ringParticipants.delete(pKey)
      Vue.delete(this.tempParticipants, pKey)
    } else {
      //固定的写入未加入中
      let json = {}
      json.name = pt.name
      json.type = pt.type
      json.canInvite = true
      json.number = pt.number
      this.inviteParticipants.unshift(json)
    }
    if (this.meetingParticipants.length <= 0 && this.ringParticipants.size <= 0) {
      this.dispose()
    }
  }

  //添加邀请（包含固定）成员
  addInviteParticipant(json) {
    if (this.inviteParticipants.length <= 0) {
      this.inviteParticipants.push(json)
      return
    }
    let participants = this.inviteParticipants.filter(i=>i.name === json.name)
    if (participants && participants.length > 0 || this.meetingParticipants.indexOf(json.name) > 0) {
      return
    }
    this.inviteParticipants.push(json)
  }

  addVcsMember(data) {
    if (data.roomName === this.name) {
      if (!this.forceRecord) {
        this.record = data.record
      }
      let participantNames = data.participantNames
      if (participantNames) {
        forEach(participantNames,pa=>{
          let name = pa.type == 1 ? pa.number : pa.name
          if (this.meetingParticipants.indexOf(name) < 0) {
            this.meetingParticipants.push(name)
            this.changeVcsMember(pa)
            main.$root.bus.$emit('meetingChange',this.meetingParticipants)
          }
        })
      }
    }
  }

  changeInviteState(key, appKey, value, delay) {
    if (!this.meeting) {
      return
    }
    if (!key) {
      key = 'name'
    }
    let reinvite = null
    for (let i = 0; i < this.inviteParticipants.length; i++) {
      let participant = this.inviteParticipants[i]
      if (participant[key] == value) {
        if (appKey) {
          if (appKey === participant.appKey) {
            reinvite = participant
            break
          }
        } else {
          reinvite = participant
          break
        }

      }
    }
    if (reinvite) {
      reinvite.canInvite = true
      if (this.reloadTimeout) {
        clearTimeout(this.reloadTimeout)
      }
      this.reloadTimeout = setTimeout(() => {
        main.$root.bus.$emit('reloadConference', this.name)
      }, delay)
    }
  }

  reloadInvite() {
    this.inviteParticipants = []
    if (this.meeting && Object.keys(this.fixParticipants).length > 0) {
      for (const key in this.fixParticipants) {
        let op = this.fixParticipants[key]
        let num = op.type == 1 ? op.number : op.name
        if (this.meetingParticipants.indexOf(num) < 0) {
          let invite = {}
          invite.name = op.name
          invite.type = op.type
          invite.canInvite = op.status == 'Idle'
          invite.number = op.number
          this.inviteParticipants.unshift(invite)
        }
      }
    }
    /*if (!this.meeting) {
      this.inviteParticipants = []
    }*/
  }

  info(key, value, appKey, type) {
    if (!key) {
      key = 'name'
    }
    let pt = null
    for (const pk in this.tempParticipants) {
      let participant = this.tempParticipants[pk]
      if (participant[key] === value) {
        if (appKey && participant.appKey === appKey) {
          pt = participant
          break
        } else {
          pt = participant
          break
        }

      }
    }
    if (!pt) {
      for (const pk in this.fixParticipants) {
        let participant = this.fixParticipants[pk]
        if (participant[key] === value) {
          if (appKey && participant.appKey === appKey) {
            pt = participant
            break
          } else {
            pt = participant
            break
          }

        }
      }
    }

    //生成消息
    let json = {}
    if (!pt) {
      json.name = value
    }else{
      json.name = pt.number
    }
    if (!json.name) {
      json.name = value
    }
    json.time = getFormatDate("HH:MM:SS", new Date())
    json.room = this.name
    json.type = type

    this.meetingInfo.unshift(json)
  }

  aysncInfo(name, type) {
    //生成消息
    let json = {}
    json.time = getFormatDate("HH:MM:SS", new Date())
    json.name = name
    json.room = this.name
    json.type = type
    json.showRoom = type != 'startShare' && type != 'endShare'
    this.meetingInfo.unshift(json)
  }

  removeInviteParticipant(key, value,appKey) {
    if (this.inviteParticipants.length < 0) {
      return
    }
    if (!key) {
      key = 'name'
    }
    let index = -1
    for (let i = 0; i < this.inviteParticipants.length; i++) {
      let ring = this.inviteParticipants[i]
      if (ring[key] === value) {
        if (appKey && ring.appKey === appKey) {
          index = i
        } else {
          index = i
        }

      }
    }
    if (index > -1) {
      this.inviteParticipants.splice(index, 1)
    }
  }

  meetings(status,screen=false) {
    let mm = []
    if (this.meetingParticipants.length < 0) {
      return mm
    }
    let control = main.$store.state.user.left
    forEach(this.meetingParticipants,m=>{
      let pt = null
      for (const key in this.fixParticipants) {
        let participant = this.fixParticipants[key]
        let pKey = participant.type == 1||participant.type == 2 ?participant.number : participant.name
        if (pKey === m) {
          pt=participant
          break
        }
      }
      if (!pt) {
        for (const key in this.tempParticipants) {
          let participant = this.tempParticipants[key]
          if (!screen && participant.isShare && !participant.isShowShare){
            continue
          }
          let pKey = participant.type == 1||participant.type == 2 ?participant.number : participant.name
          if (pKey === m) {
            pt=participant
            break
          }
        }
      }
      if (pt) {
        if (status) {
          if (pt.status === status) {
            if (pt.type == 1 && pt.number == control) {
              mm.unshift(pt)
            } else {
              mm.push(pt)
            }
          }
        } else {
          if (pt.type == 1 && pt.number == control) {
            mm.unshift(pt)
          } else {
            mm.push(pt)
          }
        }
      }
    })
    return mm
  }

  muteAll() {
    if (this.isVideo) {
      if (this.meetingParticipants.length > 0) {
        this.meetingParticipants.forEach(p=>{
          let participant = this.fixParticipants[p]
          participant = participant ? participant : this.tempParticipants[p]
          if (participant) {
            participant.setMute(true)
            this.aysncInfo(participant.name, 'mute')
          }
        })
      }
      /*for (const key in this.fixParticipants) {
        this.fixParticipants[key].setMute(true)
        this.aysncInfo(this.fixParticipants[key].name, 'mute')
      }
      for (const key in this.tempParticipants) {
        this.tempParticipants[key].setMute(true)
        this.aysncInfo(this.tempParticipants[key].name, 'mute')
      }*/
    }
  }

  unMuteAll() {
    if (this.isVideo) {
      if (this.meetingParticipants.length > 0) {
        this.meetingParticipants.forEach(p=>{
          let participant = this.fixParticipants[p]
          participant = participant ? participant : this.tempParticipants[p]
          if (participant) {
            participant.setMute(false)
            this.aysncInfo(participant.name, 'unMute')
          }
        })
      }
      /*for (const key in this.fixParticipants) {
        this.fixParticipants[key].setMute(false)
        this.aysncInfo(this.fixParticipants[key].name, 'unMute')
      }
      for (const key in this.tempParticipants) {
        this.tempParticipants[key].setMute(false)
        this.aysncInfo(this.tempParticipants[key].name, 'unMute')
      }*/
    }
  }

  inRoom(name) {
    return this.meetingParticipants.indexOf(name) > -1 || this.ringParticipants.has(name)
  }

  setForceRecord(forceRecord) {
    this.forceRecord = forceRecord
    /*if (forceRecord) {
      this.record = true
    }*/
  }

  dispose() {
    if (this.isVideo) {
      Object.values(this.tempParticipants).forEach(participant=>{
        participant.dispose()
      })
      Object.values(this.fixParticipants).forEach(participant=>{
        participant.dispose()
      })

      // 清理所有 candidate 队列
      if (this._candidateManager) {
        console.log(`Clearing ${this._candidateManager.size} pending ICE candidate queues`);
        this._candidateManager.clear();
      }
      /*for (const key in this.tempParticipants) {
        let participant = this.tempParticipants[key]
        if (participant.rtcPeer) {
          participant.dispose()
        }
      }
      for (const key in this.fixParticipants) {
        let participant = this.fixParticipants[key]
        if (participant.rtcPeer) {
          participant.dispose()
        }
      }*/
    }

    this.meeting = false
    this.record = this.forceRecord
    this.meetingParticipants = []
    this.meetingNum=0
    this.ringParticipants.clear()
    main.$root.bus.$emit('meetingChange',this.meetingParticipants)
    this.inviteParticipants = []
    this.tempParticipants = {}
    this.sharing = false
    if (this.isTemp) {
      main.$store.commit('removeRoom',this)
      main.$store.commit('setCurrRoom',null)
    }

  }
}
export default Room



// WEBPACK FOOTER //
// ./src/view/conference/room.js